import { BetSlipMode } from "../types/enums";
import { StateActionTypes } from "../types/enums";
import { dispatchCustomEvent } from "../shared/utils/bet-slip";
import { isEqual } from "lodash";

export const betBuilderHandlers: ReducerHandlers = {
  [StateActionTypes.UPDATE_BET_BUILDER_STATE]: (state, action) => {
    if (isEqual(state.betSlipState.betBuilderState, action.payload)) {
      return state;
    }
    const newBetSlipState: IBetSlipState = {
      ...state.betSlipState,
      betBuilderState: action.payload,
      mode:
        action.payload.bets.length > 0
          ? BetSlipMode.Combo
          : state.betSlipState.selections.length < 2
            ? BetSlipMode.Single
            : state.betSlipState.mode,
    };
    return {
      ...state,
      betSlipState: newBetSlipState,
    };
  },

  [StateActionTypes.CONFIRM_BET_BUILDER_REMOVAL]: (state, action) => {
    // Clear bet builder and add the pending selection from payload
    if (action.payload) {
      dispatchCustomEvent(StateActionTypes.CLEAR_ALL_BB_BETS);
      const newBetSlipState: IBetSlipState = {
        ...state.betSlipState,
        selections: [...state.betSlipState.selections, action.payload],
        betBuilderState: {
          ...state.betSlipState.betBuilderState,
          bets: [],
          totalOdds: [],
        },
      };
      return {
        ...state,
        betSlipState: newBetSlipState,
      };
    } else {
      return state;
    }
  },

  [StateActionTypes.CANCEL_BET_BUILDER_REMOVAL]: (state, action) => {
    // Just return current state - no changes needed
    return state;
  },
};
